import { Button, Modal } from "semantic-ui-react";
import { publishTable } from "../../../services/tablesService";
import { toast } from "../../..";
import { ITableDto } from "../../../models/table";
import { useMemo, useState } from "react";

interface IProps {
    publishTableModalOpen: boolean;
    closePublishTableModal: () => void;
    tableToPublish: ITableDto;
    handleClearFilter: () => void;
    refreshTables: () => void;
}

export const PublishTableModal = ({
    publishTableModalOpen,
    closePublishTableModal,
    tableToPublish,
    refreshTables,
    handleClearFilter,
}: IProps) => {
    const [loading, setLoading] = useState(false);

    const prefixText = useMemo(() => {
        return `${tableToPublish.final ? "un" : ""}`;
    }, [tableToPublish.final]);

    const publishText = useMemo(() => {
        return tableToPublish.final ? "Unpublish" : "Publish";
    }, [tableToPublish.final]);

    const handlePublishTable = async () => {
        setLoading(true);
        try {
            await publishTable(tableToPublish.guid, !tableToPublish.final);
            handleClearFilter();
            toast(`Table ${prefixText}published successfully`, true, 2000);
            refreshTables();
        } catch {
            toast(`Error ${prefixText}publishing table`, false, 2000);
        } finally {
            setLoading(false);
            closePublishTableModal();
            refreshTables();
        }
    };

    return (
        <Modal open={publishTableModalOpen} onClose={closePublishTableModal}>
            <Modal.Header>{publishText} table</Modal.Header>
            <Modal.Content>
                Are you sure you want to {prefixText}publish table {tableToPublish.name}?
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={closePublishTableModal} content="Cancel" loading={loading} />
                <Button
                    primary
                    onClick={handlePublishTable}
                    content={publishText}
                    loading={loading}
                />
            </Modal.Actions>
        </Modal>
    );
};
